import React from 'react'
import Layout from "../components/layout"
import { Container, Row } from 'reactstrap'
import Link from '../components/link'
import styled from 'styled-components'
import { Helmet } from "react-helmet"
import useSiteMetadata from '../hooks/use-site-config'
import {  Button } from 'reactstrap';
import Breadcrumb  from "../components/breadcrumb"
import PriceOfPassport from "../components/priceOfPassport"

const Text404 = styled.div`
font-size: x-large;
    width: 50%;
    margin: 4rem auto;
`
const Link404 = styled(Link)`
color: #932a7e;
font-weight: 700;
`
export const query = graphql`
query ListInfoQuery {
  site {
    siteMetadata {
      title
      description
    }
  }
  allMarkdownRemark {
    edges {
      node {
        fields{
          slug
        }
        frontmatter {
          type
          title
          childrenPath
          fatherPath
          order
          linkGetShifts
          linkLookShifts
          cover{
            childImageSharp {
              fluid(quality: 100, maxWidth: 1920) {
                  src
              }
            }
          }
        }
      }
    }
  }
}
`;

export default function PageVirtualPayment(props) {

  console.log(props)
  const { siteTitle } = useSiteMetadata()
  const title = "Pago Virtual | " + siteTitle
  const contentList = props.data.allMarkdownRemark;

  return (
    <Layout postList={contentList} here={props.pageContext.breadcrumb.location}>
      <Helmet title={title}>
        <meta charSet="utf-8" />
      </Helmet>
      <Container>
        <div className="margin-100">
        <h1 className="text-center">¿Qué debo hacer si quiero realizar mi trámite en un RegistroCivil?</h1>
          <ol className="text-larger">            
            <li>
              Aboná tu trámite con anticipación y generá el comprobante de pago.
            </li>
            <li>
              Acercate al Registro Civil elegido con el comprobante de pago, en caso de que no puedas abonar la boleta
              te indicaremos otra alternativa.
            </li>
          </ol>


          <h1 className="text-center">¿Cuáles son los medios de pago disponibles? </h1>

          <h2>DEBIN</h2>
          <p>Todos los bancos de Argentina, incluso digitales.</p>
          <h2>Débito en CBU</h2>
          <p>Visa Débito, Mastercard Debit, Maestro y Cabal Débito.</p>
          <h2>Tarjetas Prepagas</h2>
          <p>Ualá, Rapipago, Mercado Pago, Pago 24.</p>
          <h2>Tarjetas de Crédito</h2>
          <p>Visa, Mastercard, Cabal, Cordobesa, Nativa, Naranja, American Express, Diners Club
international, Argencard, Cencosud y CMR Falabella.</p>
          <h2>Home y Mobile Banking</h2>
          <p>Pago Mis Cuentas (Banelco) y Link Pagos (Red Link)</p>
          <h2>Redes de Pago Presencial</h2>
          <p>Rapipago, Pago Fácil, Cobro Express y Provincia NET.</p>


          <p className="advice"><i><b>Importante:</b> Cualquiera sea el medio de pago que elijas, recibirás un mail de confirmación con
          un código de 7 dígitos que deberás presentar al momento de realizar tu trámite presencial. El
correo te llegará dentro de las 24 y 48 hs de emitido el pago.</i></p>

          <h1>DNI </h1>
          {/* <p>El valor de todos los trámites de DNI es de 300, a excepción del “DNI Primer ejemplar” que es
          gratuito.</p>
          <p>A partir del Ejemplar D el precio del trámite varía a 450.</p> */}
          <PriceOfPassport typeSeal="DNI_ED">
          </PriceOfPassport>
          <Link to='https://tramites.renaper.gob.ar/v2/360genera.php?tipo_tramite=DNI' target="_blank" ><Button className="navBtn center"  >Abonar DNI</Button> </Link>

          <h1>DNI EXPRES</h1>
          {/* <p>El valor del trámite de DNI EXPRES es de 1500.</p> */}
          <PriceOfPassport typeSeal="DNI_EXP_MAY">
          </PriceOfPassport>
          <Link to='https://tramites.renaper.gob.ar/v2/360generaDNI240721.php' target="_blank" ><Button className="navBtn center"  >Abonar DNI EXPRES</Button> </Link>

          <h1>PASAPORTE</h1>
          {/* <p>El valor de todos los trámites de Pasaporte es de 4000.</p>
          <p><i> *El arancel no contempla el trámite de Pasaporte al Instante.</i></p> */}
          <PriceOfPassport typeSeal="PC_MAY">
          </PriceOfPassport>
          <Link to='http://tramites.renaper.gob.ar/v2/360genera.php?tipo_tramite=PAS' target="_blank" ><Button className="navBtn center"  >Abonar Pasaporte</Button> </Link>

          <h1>DNI + PASAPORTE</h1>
          {/* <p>El valor del trámite de DNI + Pasaporte es de 4300.</p>
          <p>Podés abonar la combinación de DNI + Pasaporte.</p> */}
          <PriceOfPassport typeSeal="DNI_PAS">
          </PriceOfPassport>
          <Link to='https://tramites.renaper.gob.ar/v2/360genera.php?tipo_tramite=COMBINADO' target="_blank"  ><Button className="navBtn center"  >Abonar DNI + Pasaporte</Button> </Link>
        
          <h1>PASAPORTE EXPRES</h1>
          {/* <p>El valor de los trámites de Pasaporte Expres es de 7500.</p> */}
          <PriceOfPassport typeSeal="PE_MAY">
          </PriceOfPassport>
          <Link to='https://tramites.renaper.gob.ar/v2/360generaPASAPORTEEXPRESS.php' target="_blank" ><Button className="navBtn center"  >Abonar Pasaporte</Button> </Link>
        </div>
          
      </Container>
      <Breadcrumb pageContext={props.pageContext} label="Pago Virtual"/>
    </Layout>
  );
}

